// extracted by mini-css-extract-plugin
export default {"title":"_5-z","warning":"a6-z","sizeOptionsLegendText":"b6-z"};